const STATUS_ROW_CLASS = {
  COMPLETED: 'r-success',
  ERROR:     'r-danger',
  PROGRESS:  'r-primary',  // blue for in-progress (was r-warning/yellow)
};

export function activate() {
  const table = document.getElementById('releases_table');
  if (!table) return;
  if ($.fn.DataTable.isDataTable(table)) return;

  const jsonUrl = table.dataset.source;
  if (!jsonUrl) return;

  const dt = $(table).DataTable({
    ajax: {
      url: jsonUrl,
      dataSrc: 'data',
      error: function (xhr, status, err) {
        console.error('Releases AJAX error:', status, err, xhr.responseText);
      },
    },
    deferRender: true,
    paging: false,
    order: [[0, 'desc']],
    dom: '<"d-flex justify-content-between"f>rti',
    columnDefs: [{ name: 'status', targets: 6 }],
    columns: [
      {
        data: 'id',
        render: (id) =>
          `<a href="/releases/${id}">${id}</a>`,
      },
      { data: 'instance_name', defaultContent: '' },
      { data: 'last_process',  defaultContent: '' },
      { data: 'last_log',      defaultContent: '' },
      { data: 'log_count',     defaultContent: '0' },
      {
        data: 'duration',
        render: (d) => (d != null ? `${d} mins` : ''),
      },
      {
        data: 'deploy_status',
        defaultContent: '',
      },
    ],
    createdRow(row, data) {
      const cls = STATUS_ROW_CLASS[data.deploy_status];
      if (cls) row.classList.add(cls);
      row.style.cursor = 'pointer';
      row.addEventListener('click', (e) => {
        if (e.target.tagName !== 'A') {
          window.location.href = `/releases/${data.id}`;
        }
      });
    },
    language: {
      loadingRecords: 'Loading releases…',
      processing:     'Fetching releases…',
    },
  });

  document.querySelectorAll('.releases-filter').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.releases-filter').forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');

      const status = btn.dataset.status;
      dt.column(6).search(status ? `^${status}$` : '', true, false).draw();
    });
  });
}
